/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { List, fromJS } from 'immutable';
import { RestAPI } from '../../../util/net';
import { goBack } from '../../../util/util.jsx';
import { putError } from '../../../store/error.store';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';

export const refLoaded = (state, action) => state.clear().merge(fromJS(action.data));

export const refUpdated = (state, action) =>
  state.map(ref =>
    (ref.get('id') == action.data.id ?
      ref.merge(fromJS(action.data).set('id', Number(action.data.id))) : ref));

const setHidden = (state, id, hidden) => {
  const idx = state.findIndex(item => item.get('id') == id);
  if (idx > -1) {
    return state.setIn([idx, 'hidden'], hidden);
  } return state;
};


const refCreated = (state, action) =>
  state.push(fromJS(action.data));

export const refReducer = (refName) =>
  (state = List(), action) => {
    switch (action.type) {
      case `${refName}_LOADED`:
        return refLoaded(state, action);
      case `${refName}_UPDATED_SUCCESSFULLY`:
        return refUpdated(state, action);
      case `${refName}_DELETED`:
        return setHidden(state, action.id, true);
      case `${refName}_CREATED_SUCCESSFULLY`:
        return refCreated(state, action);
      case `${refName}_RESTORED`:
        return setHidden(state, action.id, false);
      default:
        return state;
    }
  };
export const refLoad = (dispatch, refName, refPath) => {
  markStoreLoading(dispatch, refName);
  dispatch({ type: `${refName}_LOADING_STARTED` });
  return RestAPI.get(`/references/${refPath}/api`).then((data) => {
    dispatch({ type: `${refName}_LOADED`, data });
    markStoreLoaded(dispatch, refName);
    return true;
  });
};

export const refDelete = (dispatch, refName, refPath, id) => {
  dispatch({ type: `${refName}_DELETE_STARTED` });
  return RestAPI.delete(`/references/${refPath}/api/${id}`)
    .catch((data) => {
      putError(dispatch, data);
      dispatch({ type: `${refName}_DELETE_FAILED` });
      return true;
    });
};

export const refUpdate = (dispatch, refDto, refName, refPath) => {
  dispatch({ type: `${refName}_UPDATE_STARTED`, data: refDto });
  return RestAPI.patch(`/references/${refPath}/api/${refDto.id}`, refDto)
    .then(() => {
      goBack(`/references/${refPath}/${refDto.id}`);
      return true;
    }).catch((data) => {
      putError(dispatch, data);
      dispatch({ type: `${refName}_UPDATE_FAILED` });
      return true;
    }
    );
};

export const refCreatePromise = (refDto, refPath) =>
  RestAPI.put(`/references/${refPath}/api`, refDto);

export const refCreate = (dispatch, refDto, refName, refPath) => {
  dispatch({ type: `${refName}_CREATE_STARTED`, data: refDto });
  return refCreatePromise(refDto, refPath)
    .then((response) => {
      goBack(`/references/${refPath}/${response.id}`);
      return true;
    }).catch((data) => {
      putError(dispatch, data);
      dispatch({ type: `${refName}_CREATION_FAILED` });
      return true;
    }
    );
};
export const refRestore = (dispatch, refName, refPath, id) => {
  dispatch({ type: `${refName}_RESTORE_STARTED` });
  return RestAPI.patch(`/references/${refPath}/api/restore/${id}`)
    .then(() => { dispatch({ type: `${refName}_RESTORED`, id }); return true; })
    .catch((data) => {
      putError(dispatch, data);
      dispatch({ type: `${refName}_RESTORE_FAILED` });
      return true;
    });
};
